import DetailPage from "./detail/white-label-detail.page.js";
import ListPage from "./list/white-label-list.page.js";
import SkinningOptionsPage from "./detail/white-label-skining-detail.page.js";
export default {
  DetailPage,
  ListPage,
  SkinningOptionsPage
};
